<template>
    <div 
        id="favorites_setting_items"
        class="favorites-setting-items"
    >
        <div class="favorites-setting-items__title">
            <span class="text">
                {{ $t('__favorites.hint_text') }}
            </span>
            <v-icon class="close_24px" 
                color="white" 
                @click="close_dialog()"
            >
                icon-close
            </v-icon>
        </div>

        <div id="favorites_btn_area">
            <!-- 清除按鈕 -->
            <div 
                class="btn_style"
                @click.stop="delete_favorites()"
            >
                <v-icon class="icon_style">
                    icon-trash-can-regular
                </v-icon>
                <div class="icon_text_style">
                    {{ $t('__favorites.delete_text') }}
                </div>
            </div>
            <!-- 更新按鈕 -->
            <div 
                class="btn_style"
                @click.stop="update_favorites()"
            >
                <v-icon class="icon_style">
                    icon-arrow-collapse-left
                </v-icon>
                <div class="icon_text_style">
                    {{ $t('__favorites.update_text') }}
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { mapState } from 'vuex'
    import { update_my_favorites } from '@/utils/favorites/favorites'

    export default {
        name: 'FavoritesSettingItems',

        data() {
            return {
            }
        },

        computed: {
            ...mapState([
                'user',
                'client_name'
            ]),

            ...mapState('emap', [
                'selected_products',
                'selected_background_products',
            ]),

            ...mapState('favorites', [
                'zoom',
                'center',
                'basemap'
            ]),
        },

        watch: {
        },
        
        methods: {
            close_dialog () {
                this.$emit('close_dialog');
            },

            async delete_favorites () {
                let send_data = {
                    "group": this.client_name,
                    "user": this.user,
                    "webmaps_favorites": `{\"zoom\": 7, \"center\": [23.8,121.13], \"basemap\": \"black\"}`                };
                // undefined.options
                let result = await update_my_favorites(this.client_name, send_data);

                if (result.description == 'clear success') {
                    this.$emit('change_favorites_hint_text', '清除成功，請重新整理回到預設地圖');
                } else {
                    this.$emit('change_favorites_hint_text', '清除失敗');
                }
            },

            async update_favorites () {
                let meta_ids = this.selected_products.map(x => {
                    let id = x.data_name.split('_')[1];
                    return id
                })

                let geomap_ids = this.selected_background_products.map(x => {
                    let id = x.id.split('id_')[1].split('_')[0];
                    return id
                });

                let send_data = {
                    "group": this.client_name,
                    "user": this.user,
                    "webmaps_favorites": `{\"meta_ids\": [${meta_ids}], \"geomap_ids\": [${geomap_ids}], \"zoom\": ${this.zoom}, \"center\": [${this.center}], \"basemap\": \"${this.basemap}\"}`
                };
                let result = await update_my_favorites(this.client_name, send_data);

                if (result.description == 'update success') {
                    this.$emit('change_favorites_hint_text', '更新成功');
                } else {
                    this.$emit('change_favorites_hint_text', '更新失敗');
                }
            }
        }
    }
</script>

<style lang="scss" scoped>
    @import '../../../css/mixin.scss';

    .favorites-setting-items {
        position: relative;
        margin: 0 8px 0 0;
        padding: 8px 0 0;
        width: 13rem;
        min-height: 6rem;
        background-color: var(--base-dark-blue);
        border-radius: 8px;
        box-shadow: 4px 0 8px 0 rgba(0, 0, 0, .32);

        &__title {
            width: 100%;
            text-align: center;

            .text {
                color: #fff;
            }

            .close_24px {
                position: absolute;
                top: 8px;
                right: 5px;
            }
        }

        .favorites-setting-item {
            margin: 8px;
            padding: 0;
            color: #fff;
            background-color: var(--base-gray);
            border-radius: 4px;
            box-shadow: 0 2px 2px 0 rgba(0, 0, 0, .32);
        }

        #favorites_btn_area {
            display: flex;
            justify-content: center;
            align-items: center;

            .btn_style {
                display: flex;
                justify-content: center;
                align-items: center;

                min-width: 50px;
                height: 40px;
                margin: 10px 7px;
                padding-right: 6px;
                padding-left: 2px;

                border-radius: 5px;

                cursor: pointer;

                .icon_style {
                    margin-right: 3px;
                    color: white;
                    font-size: 20px;
                }

                .icon_text_style {
                    color: transparent;
                    font-size: 0px;
                }
            }

            .btn_style:hover {
                .icon_text_style {
                    color: white;
                    font-size: 14px;
                    text-align: center;
                }
            }

            .btn_style:active {
                .icon_text_style {
                    color: white;
                    font-size: 14px;
                    text-align: center;
                }
                background-color: #171d31;
                box-shadow:  0px 0px 6px rgba( #5c626b ,0.5)
            }
        }
    }
</style>